import Startup from "./Startup";

export default Startup;
